import { evaluateStrength } from './password_strength';
import { PROFILE_STEP_REVEALED_EVENT } from './required_fields_gate';

const ENTER_CLASS = 'devise-form-wrapper__step--entering';

/**
 * Advances the sign-up form from the password step to the profile step in
 * place, mirroring the SPA's client-side transition instead of a second
 * server round-trip.
 *
 * `#profile-step` is a `<fieldset disabled>` while hidden: its own `required`
 * fields (name, job title, etc.) would otherwise fail the form's constraint
 * validation and silently block the Continue click, since a merely-`hidden`
 * field still participates in validation — only `disabled` excludes it.
 *
 * `#signup-continue-button` starts `disabled` server-side and stays that way
 * until the password meets every checklist criterion (length, lowercase,
 * uppercase, number) — native `required`/`minlength` alone would let a weak
 * password like "aaaaaaaa" through. Both the initial check below and the
 * submit listener run synchronously in this same call, so the button can't
 * become clickable before the listener is in place to intercept it.
 */
export const initSignupStepTransition = () => {
  const passwordStep = document.getElementById('password-step');
  const profileStep = document.getElementById('profile-step');
  const continueButton = document.getElementById('signup-continue-button');
  const passwordField = /** @type {HTMLInputElement | null} */ (
    document.getElementById('password-field')
  );
  const form = passwordStep?.closest('form');
  if (!passwordStep || !profileStep || !continueButton || !form) return;

  const updateContinueButton = () => {
    const minLength = Number(passwordField?.dataset.minLength) || 0;
    const { criteria } = evaluateStrength(passwordField?.value ?? '', minLength);
    continueButton.disabled = !Object.values(criteria).every(Boolean);
  };

  updateContinueButton();
  passwordField?.addEventListener('input', updateContinueButton);

  form.addEventListener('submit', (event) => {
    if (!profileStep.hidden) return;

    event.preventDefault();
    passwordStep.hidden = true;
    profileStep.hidden = false;
    profileStep.disabled = false;
    profileStep.dispatchEvent(new Event(PROFILE_STEP_REVEALED_EVENT));
    profileStep.classList.add(ENTER_CLASS);
    profileStep.querySelector('.devise-form-wrapper__input:not([readonly])')?.focus();
  });
};
